

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class PaymentTransaction_ManagedObject

class PaymentTransaction_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: amount
    set amount(value:number) {
        this.setValueForKey(value, 'amount');
    }
    get amount():number {
        return this.valueForKey('amount');
    }
    set amountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'amount');
    }
    get amountPrimitiveValue():number {
        return this.primitiveValueForKey('amount');
    }

    // Property: cardTokenID
    set cardTokenID(value:string) {
        this.setValueForKey(value, 'cardTokenID');
    }
    get cardTokenID():string {
        return this.valueForKey('cardTokenID');
    }
    set cardTokenIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'cardTokenID');
    }
    get cardTokenIDPrimitiveValue():string {
        return this.primitiveValueForKey('cardTokenID');
    }

    // Property: commissionRevenue
    set commissionRevenue(value:number) {
        this.setValueForKey(value, 'commissionRevenue');
    }
    get commissionRevenue():number {
        return this.valueForKey('commissionRevenue');
    }
    set commissionRevenuePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'commissionRevenue');
    }
    get commissionRevenuePrimitiveValue():number {
        return this.primitiveValueForKey('commissionRevenue');
    }

    // Property: currencyReference
    set currencyReference(value:string) {
        this.setValueForKey(value, 'currencyReference');
    }
    get currencyReference():string {
        return this.valueForKey('currencyReference');
    }
    set currencyReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'currencyReference');
    }
    get currencyReferencePrimitiveValue():string {
        return this.primitiveValueForKey('currencyReference');
    }

    // Property: date
    set date(value:Date) {
        this.setValueForKey(value, 'date');
    }
    get date():Date {
        return this.valueForKey('date');
    }
    set datePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'date');
    }
    get datePrimitiveValue():Date {
        return this.primitiveValueForKey('date');
    }

    // Property: documentNumber
    set documentNumber(value:string) {
        this.setValueForKey(value, 'documentNumber');
    }
    get documentNumber():string {
        return this.valueForKey('documentNumber');
    }
    set documentNumberPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'documentNumber');
    }
    get documentNumberPrimitiveValue():string {
        return this.primitiveValueForKey('documentNumber');
    }

    // Property: error
    set error(value:string) {
        this.setValueForKey(value, 'error');
    }
    get error():string {
        return this.valueForKey('error');
    }
    set errorPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'error');
    }
    get errorPrimitiveValue():string {
        return this.primitiveValueForKey('error');
    }

    // Property: expirationDate
    set expirationDate(value:Date) {
        this.setValueForKey(value, 'expirationDate');
    }
    get expirationDate():Date {
        return this.valueForKey('expirationDate');
    }
    set expirationDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'expirationDate');
    }
    get expirationDatePrimitiveValue():Date {
        return this.primitiveValueForKey('expirationDate');
    }

    // Property: externalTransactionID
    set externalTransactionID(value:string) {
        this.setValueForKey(value, 'externalTransactionID');
    }
    get externalTransactionID():string {
        return this.valueForKey('externalTransactionID');
    }
    set externalTransactionIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'externalTransactionID');
    }
    get externalTransactionIDPrimitiveValue():string {
        return this.primitiveValueForKey('externalTransactionID');
    }

    // Property: fundingSource
    set fundingSource(value:string) {
        this.setValueForKey(value, 'fundingSource');
    }
    get fundingSource():string {
        return this.valueForKey('fundingSource');
    }
    set fundingSourcePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'fundingSource');
    }
    get fundingSourcePrimitiveValue():string {
        return this.primitiveValueForKey('fundingSource');
    }

    // Property: isCardCommercial
    set isCardCommercial(value:boolean) {
        this.setValueForKey(value, 'isCardCommercial');
    }
    get isCardCommercial():boolean {
        return this.valueForKey('isCardCommercial');
    }
    set isCardCommercialPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'isCardCommercial');
    }
    get isCardCommercialPrimitiveValue():boolean {
        return this.primitiveValueForKey('isCardCommercial');
    }

    // Property: isRefunded
    set isRefunded(value:boolean) {
        this.setValueForKey(value, 'isRefunded');
    }
    get isRefunded():boolean {
        return this.valueForKey('isRefunded');
    }
    set isRefundedPrimitiveValue(value:boolean) {
        this.setPrimitiveValueForKey(value, 'isRefunded');
    }
    get isRefundedPrimitiveValue():boolean {
        return this.primitiveValueForKey('isRefunded');
    }

    // Property: issuerCountry
    set issuerCountry(value:string) {
        this.setValueForKey(value, 'issuerCountry');
    }
    get issuerCountry():string {
        return this.valueForKey('issuerCountry');
    }
    set issuerCountryPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'issuerCountry');
    }
    get issuerCountryPrimitiveValue():string {
        return this.primitiveValueForKey('issuerCountry');
    }

    // Property: legalEntityName
    set legalEntityName(value:string) {
        this.setValueForKey(value, 'legalEntityName');
    }
    get legalEntityName():string {
        return this.valueForKey('legalEntityName');
    }
    set legalEntityNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'legalEntityName');
    }
    get legalEntityNamePrimitiveValue():string {
        return this.primitiveValueForKey('legalEntityName');
    }

    // Property: locationID
    set locationID(value:string) {
        this.setValueForKey(value, 'locationID');
    }
    get locationID():string {
        return this.valueForKey('locationID');
    }
    set locationIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'locationID');
    }
    get locationIDPrimitiveValue():string {
        return this.primitiveValueForKey('locationID');
    }

    // Property: locationName
    set locationName(value:string) {
        this.setValueForKey(value, 'locationName');
    }
    get locationName():string {
        return this.valueForKey('locationName');
    }
    set locationNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'locationName');
    }
    get locationNamePrimitiveValue():string {
        return this.primitiveValueForKey('locationName');
    }

    // Property: merchantReference
    set merchantReference(value:string) {
        this.setValueForKey(value, 'merchantReference');
    }
    get merchantReference():string {
        return this.valueForKey('merchantReference');
    }
    set merchantReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'merchantReference');
    }
    get merchantReferencePrimitiveValue():string {
        return this.primitiveValueForKey('merchantReference');
    }

    // Property: merchantReferenceName
    set merchantReferenceName(value:string) {
        this.setValueForKey(value, 'merchantReferenceName');
    }
    get merchantReferenceName():string {
        return this.valueForKey('merchantReferenceName');
    }
    set merchantReferenceNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'merchantReferenceName');
    }
    get merchantReferenceNamePrimitiveValue():string {
        return this.primitiveValueForKey('merchantReferenceName');
    }

    // Property: orderNumber
    set orderNumber(value:string) {
        this.setValueForKey(value, 'orderNumber');
    }
    get orderNumber():string {
        return this.valueForKey('orderNumber');
    }
    set orderNumberPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'orderNumber');
    }
    get orderNumberPrimitiveValue():string {
        return this.primitiveValueForKey('orderNumber');
    }

    // Property: paymentDate
    set paymentDate(value:Date) {
        this.setValueForKey(value, 'paymentDate');
    }
    get paymentDate():Date {
        return this.valueForKey('paymentDate');
    }
    set paymentDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'paymentDate');
    }
    get paymentDatePrimitiveValue():Date {
        return this.primitiveValueForKey('paymentDate');
    }

    // Property: paymentFee
    set paymentFee(value:number) {
        this.setValueForKey(value, 'paymentFee');
    }
    get paymentFee():number {
        return this.valueForKey('paymentFee');
    }
    set paymentFeePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'paymentFee');
    }
    get paymentFeePrimitiveValue():number {
        return this.primitiveValueForKey('paymentFee');
    }

    // Property: payMethodSubtype
    set payMethodSubtype(value:string) {
        this.setValueForKey(value, 'payMethodSubtype');
    }
    get payMethodSubtype():string {
        return this.valueForKey('payMethodSubtype');
    }
    set payMethodSubtypePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'payMethodSubtype');
    }
    get payMethodSubtypePrimitiveValue():string {
        return this.primitiveValueForKey('payMethodSubtype');
    }

    // Property: payMethodType
    set payMethodType(value:number) {
        this.setValueForKey(value, 'payMethodType');
    }
    get payMethodType():number {
        return this.valueForKey('payMethodType');
    }
    set payMethodTypePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'payMethodType');
    }
    get payMethodTypePrimitiveValue():number {
        return this.primitiveValueForKey('payMethodType');
    }

    // Property: previousTransactionID
    set previousTransactionID(value:string) {
        this.setValueForKey(value, 'previousTransactionID');
    }
    get previousTransactionID():string {
        return this.valueForKey('previousTransactionID');
    }
    set previousTransactionIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'previousTransactionID');
    }
    get previousTransactionIDPrimitiveValue():string {
        return this.primitiveValueForKey('previousTransactionID');
    }

    // Property: proxyTransactionID
    set proxyTransactionID(value:string) {
        this.setValueForKey(value, 'proxyTransactionID');
    }
    get proxyTransactionID():string {
        return this.valueForKey('proxyTransactionID');
    }
    set proxyTransactionIDPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'proxyTransactionID');
    }
    get proxyTransactionIDPrimitiveValue():string {
        return this.primitiveValueForKey('proxyTransactionID');
    }

    // Property: refundAmount
    set refundAmount(value:number) {
        this.setValueForKey(value, 'refundAmount');
    }
    get refundAmount():number {
        return this.valueForKey('refundAmount');
    }
    set refundAmountPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'refundAmount');
    }
    get refundAmountPrimitiveValue():number {
        return this.primitiveValueForKey('refundAmount');
    }

    // Property: refundDate
    set refundDate(value:Date) {
        this.setValueForKey(value, 'refundDate');
    }
    get refundDate():Date {
        return this.valueForKey('refundDate');
    }
    set refundDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'refundDate');
    }
    get refundDatePrimitiveValue():Date {
        return this.primitiveValueForKey('refundDate');
    }

    // Property: refundTransactionReference
    set refundTransactionReference(value:string) {
        this.setValueForKey(value, 'refundTransactionReference');
    }
    get refundTransactionReference():string {
        return this.valueForKey('refundTransactionReference');
    }
    set refundTransactionReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'refundTransactionReference');
    }
    get refundTransactionReferencePrimitiveValue():string {
        return this.primitiveValueForKey('refundTransactionReference');
    }

    // Property: status
    set status(value:number) {
        this.setValueForKey(value, 'status');
    }
    get status():number {
        return this.valueForKey('status');
    }
    set statusPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'status');
    }
    get statusPrimitiveValue():number {
        return this.primitiveValueForKey('status');
    }

    // Property: transactionFee
    set transactionFee(value:number) {
        this.setValueForKey(value, 'transactionFee');
    }
    get transactionFee():number {
        return this.valueForKey('transactionFee');
    }
    set transactionFeePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'transactionFee');
    }
    get transactionFeePrimitiveValue():number {
        return this.primitiveValueForKey('transactionFee');
    }

    // Property: transactionReference
    set transactionReference(value:string) {
        this.setValueForKey(value, 'transactionReference');
    }
    get transactionReference():string {
        return this.valueForKey('transactionReference');
    }
    set transactionReferencePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'transactionReference');
    }
    get transactionReferencePrimitiveValue():string {
        return this.primitiveValueForKey('transactionReference');
    }

    // Property: transactionSequence
    set transactionSequence(value:number) {
        this.setValueForKey(value, 'transactionSequence');
    }
    get transactionSequence():number {
        return this.valueForKey('transactionSequence');
    }
    set transactionSequencePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'transactionSequence');
    }
    get transactionSequencePrimitiveValue():number {
        return this.primitiveValueForKey('transactionSequence');
    }

    // Property: userInfo
    set userInfo(value:any) {
        this.setValueForKey(value, 'userInfo');
    }
    get userInfo():any {
        return this.valueForKey('userInfo');
    }
    set userInfoPrimitiveValue(value:any) {
        this.setPrimitiveValueForKey(value, 'userInfo');
    }
    get userInfoPrimitiveValue():any {
        return this.primitiveValueForKey('userInfo');
    }
    // Relationship: cashDeskLine
    set cashDeskLine(value:CashDeskLine) {
        this.setValueForKey(value, 'cashDeskLine');
    }
    get cashDeskLine():CashDeskLine {
        return this.valueForKey('cashDeskLine') as CashDeskLine;
    }
    // Relationship: legalEntity
    set legalEntity(value:LegalEntity) {
        this.setValueForKey(value, 'legalEntity');
    }
    get legalEntity():LegalEntity {
        return this.valueForKey('legalEntity') as LegalEntity;
    }
    // Relationship: location
    set location(value:Location) {
        this.setValueForKey(value, 'location');
    }
    get location():Location {
        return this.valueForKey('location') as Location;
    }
    // Relationship: paymentEntity
    set paymentEntity(value:PaymentEntity) {
        this.setValueForKey(value, 'paymentEntity');
    }
    get paymentEntity():PaymentEntity {
        return this.valueForKey('paymentEntity') as PaymentEntity;
    }
}
